import type { BariPreCaroInactivityPoliReportData } from '@common/validation/customControls/bariPre/bariPreCaroInactivityPoliReport/v1/bariPreCaroInactivityPoliReportSchemaV1';
import { CustomControlCode } from '@common/enums';
import { CustomControlRegistry } from '@frontend/components/pages/episodeCategory/customControls/customControlRegistry';
import { initialData } from './bariPreCaroInactivityPoliReportData';
import { BariPreCaroInactivityPoliReportEdit } from './BariPreCaroInactivityPoliReportEdit';
import { BariPreCaroInactivityPoliReportRead } from './BariPreCaroInactivityPoliReportRead';

CustomControlRegistry.instance.register<BariPreCaroInactivityPoliReportData>({
    EditElement: BariPreCaroInactivityPoliReportEdit,
    ReadElement: BariPreCaroInactivityPoliReportRead,
    code: CustomControlCode.BariPreCaroInactivityPoliReport,
    initialData,
    version: 1,
});
